export default __webpack_public_path__ + "static/media/whyus_2.0da9eb89.png";